<template>
  <li
    class="tabs__nav--item"
    tabindex="0"
    :class="{'tabs--expanded': tabExpand(tabId)}"
    @click="gotoTab($event, getTabId)"
  >
    <a>
      <slot name="tabs__nav--item" />
    </a>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

/**
  * @vue
  */
export default {
  name: 'tabs-nav',

  props: {
    tabId: {
      type: String,
      required: true
    },

    expanded: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    ...mapGetters([
      'tabExpand',
      'getTabId'
    ])
  },

  mounted() {
    /* istanbul ignore next  */
    if (this.expanded || this.expanded === 'true') {
      this.$store.commit('setCurrentTabItem', this.tabId)
    }
  },

  methods: {
    /**
      * Activate the selected tab
      * @param {event} click event handler
      * @param {getTabId} sends ID of clicked tab
      */
    gotoTab($event, getTabId) {
      /* istanbul ignore if  */
      if (getTabId !== this.tabId && this.$parent.directNavigation) {
        $event.preventDefault()
        this.$store.commit('setCurrentTabItem', this.tabId)
      }
    }
  }

}
</script>
